var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"definition-list cf"},[_vm._l((_vm.keysValues),function({ key, value },idx){return [_c('dt',{key:idx + key,staticClass:"definition-list__label"},[_vm._v(_vm._s(_vm.$te(key) ? _vm.$t(key) : key))]),_c('dd',{key:idx + value,staticClass:"definition-list__value"},[_vm._v(_vm._s(_vm.$te(value) ? _vm.$t(value) : value))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }